<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-form @submit.prevent="addItem">
          <b-row>
            <b-col cols="12" class="mb-3">
              <b-button variant="primary" @click="$router.go(-1)" class="pull-left">Terug</b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-card>
                <template slot="header">
                  Campagne toevoegen
                </template>
                <b-row>
                  <b-col cols="12">
                    <b-row>
                      <b-col>
                        <h5>Basisgegevens</h5>
                        <hr>
                        <b-row>
                          <b-col cols="12" md="6">
                            <b-form-group label="Campagne">
                              <b-form-input type="text" required v-model="item.campaign"></b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col cols="12" md="6">
                            <b-form-group label="Actief">
                              <b-form-select :options="isActiveOptions" v-model="item.is_active"/>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <template slot="footer">
                    <b-button type="submit" variant="success" class="pull-right" :disabled="saveButtonDisabled">Toevoegen</b-button>
                </template>
              </b-card>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>
  </div>
</template>
<script>
  import { addData } from '@/api';

  export default {
    name: 'campaign-action',
    props: ['id'],
    data() {
      return {
        saveButtonDisabled: false,
        item: {
          campaign: 'GRV2023',
          is_active: 1,
        },
        isActiveOptions: [
          {
            text: 'Ja',
            value: 1
          },
          {
            text: 'Nee',
            value: 0
          },
        ],
        municipalityOptions: [],
      };
    },
    methods: {
      async addItem() {
        this.saveButtonDisabled = true;
        const request = await addData(
          'questionnaires',
          {
            name: this.item.campaign,
            campaign: this.item.campaign,
            is_active: this.item.is_active,
          }
        );
        if (request.status === 201) {
          this.$router.push({ name: 'questionnaires.view', params: { id: request.data.data.id } });
        } else {
          this.saveButtonDisabled = false;
        }
      },
    },
    beforeMount() {
      this.getMunicipalityOptions();
    },
  };

</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
